<div class="row">
  <div class="col-md-4">
    <div class="card-counter success">
      <i class="material-icons">store</i>
      <span class="count-numbers">{{TotalNoOfStores  }}</span>
      <span class="count-name">Number of Stores</span>
    </div>
  </div>
  <div class="col-md-4">
    <div class="card-counter danger">
      <i class="material-icons">shopping_cart</i>
      <span class="count-numbers">{{TotalNoOfPublishedProducts }}</span>
      <span class="count-name">Published Products</span>
    </div>
  </div>
  <div class="col-md-4">
    <div class="card-counter card-counter-list info">
      <a [routerLink]="[ '/store/list']">
        <p>
          Stores
          <i class="fa fa-angle-double-right pulsate"></i>
        </p>
      </a>
      <a [routerLink]="[ '/store/customizedproducts']">
        <!-- <p (click)="showAddProductWindow()"> -->
        <p>
          Product Library
          <i class="fa fa-angle-double-right pulsate"></i>
        </p>
      </a>
      <a [routerLink]="[ '/store/publishedproducts']">       
        <p>
          Published Products
          <i class="fa fa-angle-double-right pulsate"></i>
        </p>
      </a>
      <a [routerLink]="[ '/store/report/orders']">
        <p>
          Orders
          <i class="fa fa-angle-double-right pulsate"></i>
        </p>
      </a>
      <a [routerLink]="[ '/store/commissions']">
        <p>
          Commission
          <i class="fa fa-angle-double-right pulsate"></i>
        </p>
      </a>
    </div>
  </div>
</div>

<div class="select-store-dashboard">
  <form [formGroup]="form" >
    Displaying data for store
    <mat-select class="order-st-select"
                (selectionChange)="onChange($event.value)"
                formControlName="StoreId">
      <mat-option *ngFor="let storeItem of storeList" [value]="storeItem.StoreId">
        {{storeItem.StoreName }}
      </mat-option>
    </mat-select>
  </form>


  <div class="row">
    <div class="col-lg-2 col-md-4">
      <div class="circle-tile ">
        <a href="javaScript:void(0)">
          <div class="circle-tile-heading red">
            <i class="material-icons pulsate">people_outline</i>
          </div>
        </a>
        <div class="circle-tile-content red">
          <div class="circle-tile-description text-faded">Users</div>
          <div class="circle-tile-number text-faded ">{{GetTotalEndUsersOfStore  }}</div>
          <a class="circle-tile-footer" href="{{StoreUrl}}" target="_blank">
            {{StoreUrl}}
            <i class="fa fa-angle-double-right pulsate"></i>
          </a>
        </div>
      </div>
    </div>
    <div class="col-lg-2 col-md-4">
      <div class="circle-tile ">
        <a href="javaScript:void(0)">
          <div class="circle-tile-heading dark-blue">
            <i class="material-icons pulsate">access_alarm</i>
          </div>
        </a>
        <div class="circle-tile-content dark-blue">
          <div class="circle-tile-description text-faded">Daily Visitors</div>
          <div class="circle-tile-number text-faded ">{{getDailyVisitors  }}</div>
          <a class="circle-tile-footer" href="{{StoreUrl}}" target="_blank">{{StoreUrl}}   <i class="fa fa-angle-double-right pulsate"></i></a>
        </div>
      </div>
    </div>
    <div class="col-lg-2 col-md-4">
      <div class="circle-tile ">
        <a href="javaScript:void(0)">
          <div class="circle-tile-heading orange">
            <i class="material-icons pulsate">attach_money</i>
          </div>
        </a>
        <div class="circle-tile-content orange">
          <div class="circle-tile-description text-faded">Earning</div>
          <div class="circle-tile-number text-faded ">{{isNumber(getStoreAdminEarningReportAp) ? (getStoreAdminEarningReportAp|currency:'USD':true:'1.2-2') : 0 }}</div>
          <a class="circle-tile-footer" href="{{StoreUrl}}" target="_blank">{{StoreUrl}}   <i class="fa fa-angle-double-right pulsate"></i></a>
        </div>
      </div>
    </div>
    <div class="col-lg-2 col-md-4">
      <div class="circle-tile ">
        <a href="javaScript:void(0)">
          <div class="circle-tile-heading purple">
            <i class="material-icons pulsate">brush</i>
          </div>
        </a>
        <div class="circle-tile-content purple">
          <div class="circle-tile-description text-faded">Designs Viewed </div>
          <div class="circle-tile-number text-faded ">{{getDesignViewedCount }}</div>
          <a class="circle-tile-footer" href="{{StoreUrl}}" target="_blank">{{StoreUrl}}   <i class="fa fa-angle-double-right pulsate"></i></a>
        </div>
      </div>
    </div>
    <div class="col-lg-2 col-md-4">
      <div class="circle-tile ">
        <a href="javaScript:void(0)">
          <div class="circle-tile-heading green">
            <i class="material-icons pulsate">add_shopping_cart</i>
          </div>
        </a>
        <div class="circle-tile-content green">
          <div class="circle-tile-description text-faded">Open Carts</div>
          <div class="circle-tile-number text-faded ">{{getOpenCartsQuery }}</div>
          <a class="circle-tile-footer" href="{{StoreUrl}}" target="_blank">{{StoreUrl}}   <i class="fa fa-angle-double-right pulsate"></i></a>
        </div>
      </div>
    </div>
    <div class="col-lg-2 col-md-4">
      <div class="circle-tile ">
        <div class="circle-tile-heading">
        </div>
        <div class="circle-tile-content">
          <div class="circle-tile-description text-faded">
            <a href="{{StoreUrl}}" target="_blank" class="btn btn-sm btn-info" style="font-size: 12px;">
              <i class="fa fa-external-link" aria-hidden="true"></i> {{StoreUrl}}
            </a>
          </div>
        </div>
      </div>

    </div>
  </div>
</div>








<!--<div [ngClass]="'tile-block-wrp ' + color">
  <div class="tile-block">
    <div *ngIf="!topDesign" class="row">
      <div class="col-8">
        <div class="vw-ad-sbgrd">
          <h4>{{ title }}</h4>
          <p></p>
          <div counto
               step="30"
               [countTo]="count"
               countFrom="0"
               duration="2"
               (countoChange)="countTo = $event">
            <h3>{{ countTo | number: "1.0-0" }}</h3>
          </div>
        </div>
      </div>
      <div class="col-4 align-self-center">
        <div class="round-block">
          <i class="material-icons pulsate">{{ icon }}</i>
        </div>
      </div>
    </div>
    <div *ngIf="topDesign" class="row">
      <div class="col-4 align-self-center">
        <div class="round-block">
          <i class="material-icons pulsate">{{ icon }}</i>
        </div>
      </div>
      <div class="col-8">
        <div counto
             [step]="30"
             [countTo]="count"
             [countFrom]="0"
             [duration]="3"
             (countoChange)="countTo = $event">
          <h4 *ngIf="currency">{{ countTo | currency: "USD":"symbol":"1.2-4" }}</h4>
          <h4 *ngIf="!currency">{{ countTo | number: "1.0-0" }}</h4>
        </div>
        <p>{{title}}</p>
      </div>
    </div>
  </div>
  <label *ngIf="static" [ngClass]="'label ' + labelClass">Number of Stores</label>
  <form *ngIf="!static" [formGroup]="form">
    <label [ngClass]="'label ' + labelClass">
      <mat-form-field>
        <mat-select class="order-st-select"
                    (selectionChange)="onChange($event.value)"
                    formControlName="StoreId">
          <mat-option *ngFor="let storeItem of storeList"
                      [value]="storeItem.StoreId">{{ storeItem.StoreName }}</mat-option>
        </mat-select>
      </mat-form-field>
    </label>
  </form>
</div>-->
